import { useQuery } from '@tanstack/react-query';
import { getBanners, getTerms } from '@/services/homeService';
import { queryKeys } from './queryKeys';

/**
 * Hook to fetch banner data
 */
export const useBanners = () => {
  return useQuery({
    queryKey: queryKeys.home.banner(),
    queryFn: getBanners,
  });
};

/**
 * Hook to fetch terms and conditions
 */
export const useTerms = () => {
  return useQuery({
    queryKey: queryKeys.home.terms(),
    queryFn: getTerms,
  });
};
